import { render, staticRenderFns } from "./InstagramV2Channels.vue?vue&type=template&id=6f6ce463&scoped=true"
import script from "./InstagramV2Channels.vue?vue&type=script&lang=js"
export * from "./InstagramV2Channels.vue?vue&type=script&lang=js"
import style0 from "./InstagramV2Channels.vue?vue&type=style&index=0&id=6f6ce463&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f6ce463",
  null
  
)

export default component.exports